import React from 'react'
import PropTypes from 'prop-types'
import Dialog from 'material-ui/Dialog'
import FlatButton from 'material-ui/FlatButton'

export default class Results extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			open: false,
		}

		this.handleSubmit = () => {
			this.setState({ open: false })
			this.props.remove()
		}
	}

	render() {
		const actions = [
			<FlatButton
				label="Cancel"
				onTouchTap={() => { this.setState({ open: false }) }}
			/>,
			<FlatButton
				label="Delete"
				onTouchTap={this.handleSubmit}
				primary
			/>,
		]

		return (
			<div className="action center remove">
				<FlatButton
					label="Delete poll"
					onClick={() => { this.setState({ open: true }) }}
					secondary
					style={{ color: 'red' }}
				/>
				<Dialog
					actions={actions}
					modal
					open={this.state.open}
					title="Delete poll?"
				>
					This action cannot be undone. Permanently delete poll?
				</Dialog>
			</div>
		)
	}
}

Results.propTypes = {
	remove: PropTypes.func.isRequired,
}



// WEBPACK FOOTER //
// ./src/components/results/Remove.jsx